module.exports = __webpack_public_path__ + "img/user-up-02.61f4f16e.svg";